<template>
  <div class="calendar-date-selector">
    <span @click="selectPrevious" v-if="calendarListSelected"><i class="ah_icon i-arrow-left"></i></span>
    <span>{{ selectedMonth }}</span>
    <span @click="selectNext" v-if="calendarListSelected"><i class="ah_icon i-arrow-right"></i></span>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "CalendarModeSelector",

  props: {
    currentDate: {
      type: String,
      required: true
    },

    selectedDate: {
      type: Object,
      required: true
    },

    calendarListSelected: {
      type: String,
    }
  },

  methods: {
    selectPrevious() {
      let newSelectedDate = dayjs(this.selectedDate).subtract(1, "month");
      this.$emit("dateSelected", newSelectedDate);
    },

    selectCurrent() {
      let newSelectedDate = dayjs(this.currentDate);
      this.$emit("dateSelected", newSelectedDate);
    },

    selectNext() {
      let newSelectedDate = dayjs(this.selectedDate).add(1, "month");
      this.$emit("dateSelected", newSelectedDate);
    }
  },

  computed: {
    selectedMonth() {
      return this.selectedDate.format("MMMM YYYY");
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ./src/components/CalendarDateSelector.vue